// extracted by mini-css-extract-plugin
export default {"badge":"VelocityBadge_badge__RL+BH","fast":"VelocityBadge_fast__zSxbu","medium":"VelocityBadge_medium__AalL1","slow":"VelocityBadge_slow__PfPy8"};